import useCallApi from '../../utilities/axios'
import * as umServinceURL from './umServiceURL'

export type FormProps = {
    username: string
    email: string
    position: string
    positionTH: string
    positionEN: string
    academicPositionDr: string
    title: string
    titleTH: string
    titleEN: string
    nameTH: string
    nameEN: string
    telephone: string
    isPhD: boolean
    cu_net: boolean
    isPasscode: boolean
    signatureEN: string | null
    signatureTH: string | null
    usergroupID: number[]
    departments_en: string
}

export type FormChangePasscodeProps = {
    passcode: string
    newPasscode: string
}

export type ChangePasscodeProps = {
    id: number
    passcode: string
    newPasscode: string
}

const usePreferenceProfile = () => {
    const callApi = useCallApi()
    const token = localStorage.getItem('accessToken')

    const getPreferanceProfile = async (userId: number | null) => {
        if (userId) {
            try {
                const { data } = await callApi.axiosGet<any>({
                    url: `${umServinceURL.getPreferencesProfile}/${userId}`,
                })

                return {
                    ...data,
                    position: data.position?.id,
                    title: data.title?.id,
                    positionTH: data.position?.name?.th,
                    positionEN: data.position?.name?.en,
                    titleTH: data.title?.name?.th,
                    titleEN: data.title?.name?.en,
                }
            } catch (error) {
                console.log('error getPreferanceProfile', error)
            }
        }
    }

    const forgotPassword = async (email: string) => {
        try {
            const { data } = await callApi.axiosPost<any>({
                url: `${umServinceURL.postPreferencesForgotPassword}`,
                authorizationType: 'authorization',
                params: {
                    email: email,
                },
            })
            return data
        } catch (error) {
            console.log('error forgotPassword', error)
        }
    }

    const putPreferanceProfile = async (userId: number | null, param: FormProps) => {
        const format = {
            ...param,
            title: {
                id: Number(param.title),
                name: {
                    th: param.titleTH ?? null,
                    en: param.titleEN ?? null,
                },
            },
            position: {
                id: Number(param.position),
                name: {
                    th: param.positionTH ?? null,
                    en: param.positionEN ?? null,
                },
            },
        }
        if (userId) {
            try {
                const { data } = await callApi.axiosPut<any>({
                    url: `${umServinceURL.putPreferencesProfile}/${userId}`,
                    params: format,
                })
                return data
            } catch (error) {
                console.log('error', error)
            }
        }
    }

    const postImage = async (formData: FormData) => {
        const { data } = await callApi.axiosPost<any>({
            url: umServinceURL.postImageProfile,
            params: formData,
        })

        return data
    }

    const postImageLogo = async (formData: FormData) => {
        const { data } = await callApi.axiosPost<any>({
            url: umServinceURL.postImageLogoProfile,
            params: formData,
        })

        return data
    }

    const putEmailSetting = async (isEnabled: boolean) => {
        const { data } = await callApi.axiosPut<any>({
            url: umServinceURL.updateEmailSetting,
            params: {
                isEnable: isEnabled,
            },
        })

        return data
    }

    return {
        getPreferanceProfile,
        putPreferanceProfile,
        forgotPassword,
        postImage,
        postImageLogo,
        putEmailSetting,
    }
}

export default usePreferenceProfile
